import Vue from "vue";
import Router from "vue-router";
import Login from "../login/Login";
import Dashboard from "../../client/home/Dashboard";
import Integrations from "../../accountant/integrations/Integrations";
import Notas from "../../client/notas/Notas";
import Resetpassword from "../password/Resetpassword";
import Forgotpassword from "../password/Forgotpassword";
import Perfilconfig from "../../client/perfil/Perfil";
import RequestsAccountant from "../../accountant/requests/Requests";
import DocumentsAccountant from "../../accountant/documents/Documents";
import SpedsAccountant from "../../accountant/speds/Speds";
import RequestsClients from "../../client/requests/RequestsClient";
import PerfilAccountant from "../../accountant/perfil/Perfil";
import NewAccountant from "../newaccountant/NewAccountant";
import Speds from "../../client/sped/Speds.vue";
import SupportLimitDate from "../customException/SupportLimitDate";
import TermsAcceptance from "../customException/TermsAcceptance";
import InvalidDocument from "../customException/InvalidDocument";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/accountant/betaIntegrations",
      name: "Integrations",
      component: Integrations
    },
    {
      path: "/notas/:model",
      name: "Notas",
      component: Notas
    },
    {
      path: "/forgot-password",
      name: "Forgotpassword",
      component: Forgotpassword
    },
    {
      path: "/support/password-reset/:mailtoken",
      name: "Resetpassword",
      component: Resetpassword
    },
    {
      path: "/config/perfil",
      name: "Perfil",
      component: Perfilconfig
    },
    {
      path: "/accountant/dashboard",
      name: "Dashboard Client",
      component: Dashboard
    },
    {
      path: "/accountant/requests",
      name: "Requests Accountant",
      component: RequestsAccountant
    },
    {
      path: "/requests",
      name: "Requests Client",
      component: RequestsClients
    },
    {
      path: "/accountant/documents",
      name: "Documents Client",
      component: DocumentsAccountant
    },
    {
      path: "/accountant/speds",
      name: "Speds Client",
      component: SpedsAccountant
    },
    {
      path: "/accountant/perfil",
      name: "Perfil Accountant",
      component: PerfilAccountant
    },
    {
      path: "/newaccountant",
      name: "NewAccountant",
      component: NewAccountant
    },
    {
      path: "/support",
      name: "customException",
      component: SupportLimitDate
    },
    {
      path: "/terms-acceptance",
      name: "termsAcceptance",
      component: TermsAcceptance
    },
    {
      path: "/invalid-documents",
      name: "invalidDocument",
      component: InvalidDocument
    },
    {
      path: "/sped",
      name: "Speds",
      component: Speds
    }
  ]
});



// WEBPACK FOOTER //
// ./src/public/router/index.js